<template lang="pug">
  section.section
    Loader(v-show="isLoading")
    .container
      .columns
        .column
          a.button.is-dark.is-rounded.is-small(@click="cerrarArticulo")
            | Cerrar &nbsp
            i.fas.fa-times
          br
      .columns
        .column.is-2
          .field
            label.label Marca
            .control
              input.input.is-primary(
                type='text', 
                placeholder='Marca',
                v-model="marca",
              )
        .column.is-2
          .field
            label.label Modelo
            .control
              input.input.is-primary(
                type='text', 
                placeholder='Modelo',
                v-model="modelo",
              )
        .column.is-2
          .field
            label.label # Serie
            .control
              input.input.is-primary(
                type='text', 
                placeholder='# Serie',
                v-model="serie",
              )
        .column.is-2
          .field
            label.label Tipo
            .control
              typeahead(:options="tipos" :optionSelect="itemData" v-model="itemSel")
      .columns
        .column.is-2
          .field
            label.label Oficina
            .control.has-icons-left
              .select.is-primary.is-rounded
                select(v-model="oficina")
                  option(v-for="ofi in oficinasSel" :value="ofi.id") {{ ofi.nombre }}
              .icon.is-small.is-left
                i.fas.fa-map-pin
        .column.is-2
          .field
            label.label Orden de Compra
            .control
              input.input.is-primary(
                type='text', 
                placeholder='Orden de Compra',
                v-model="ordenCompra",
              )        
        .column.is-2
          .field
            label.label Estado
            .control.has-icons-left
              .select.is-primary.is-rounded
                select(v-model="estado")
                  option(value="" checked) Estado
                  option(value='1' checked='') NUEVO
                  option(value='2') USADO
                  option(value='3') INSTALADO
                  option(value='4') NO SIRVE
              .icon.is-small.is-left
                i.fas.fa-box-open
        .column.is-2
          .field
            label.label Observaciones
            .control
              textarea.textarea.is-primary(
                placeholder='Observaciones',
                v-model="observaciones")
      .columns
        .column.is-12
          a.button.is-primary.is-rounded.is-medium(@click="saveItem" v-show="!isSaved && !isEditing") Guardar
          a.button.is-warning.is-rounded.is-medium(@click="editItem" v-show="isSaved && !isEditing") Editar
          a.button.is-success.is-rounded.is-medium(@click="updateItem" v-show="!isSaved && isEditing") Actualizar
          a.button.is-default.is-rounded.is-medium(@click="cancelEditItem" v-show="!isSaved && isEditing") Cancelar
          
</template>

<script>
import Loader from '../shared/Loader.vue'
import InventarioServices from '../../services/inventario/inventario';
import Typeahead from '@/components/inventario_Componentes/Typeahead.vue'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'FormArticulo',
  components: { Loader, Typeahead },
  props: {
    alta: {},
    itemEdit: {},
  },
  data () {
    return {
      serie: '',
      marca: '',
      modelo: '',
      oficina: '',
      ordenCompra: '',
      observaciones: '',
      estado: '',
      isDisabled: false,
      isEditing: false,
      isSaved: false,
      isLoading: false,
      dataItemEdit: {},
      tipos: [],
      itemSel: {},
      itemData: {},
      oficinas: [
        { 'id': 'TPA-ADM', 'nombre': 'Of. Admin.', 'source': 'TPA' },
        { 'id': 'TPA-ALM', 'nombre': 'Almacen', 'source': 'TPA' },
        { 'id': 'TPA-CC', 'nombre': 'Cuarto de Control', 'source': 'TPA' },
        { 'id': 'TPA-FAC', 'nombre': 'Facturación', 'source': 'TPA' },
        { 'id': 'TPA-BAS', 'nombre': 'Báscula', 'source': 'TPA' },
        { 'id': 'TPA-GER', 'nombre': 'Gerencia', 'source': 'TPA' },
        { 'id': 'TPA-ALS', 'nombre': 'Almacen Sist.', 'source': 'TPA' },
        { 'id': 'TPA-MUE', 'nombre': 'Muelle', 'source': 'TPA' },
        { 'id': 'IRGE-ADM', 'nombre': 'Of. Admin.', 'source': 'IRGE' },
        { 'id': 'IRGE-ALM', 'nombre': 'Almacen', 'source': 'IRGE' },
        { 'id': 'IRGE-CC', 'nombre': 'Cuarto de Control', 'source': 'IRGE' },
        { 'id': 'IRGE-FAC', 'nombre': 'Facturación', 'source': 'IRGE' },
        { 'id': 'IRGE-BAS', 'nombre': 'Báscula', 'source': 'IRGE' },
        { 'id': 'IRGE-GER', 'nombre': 'Gerencia', 'source': 'IRGE' },
        { 'id': 'EB04-CC', 'nombre': 'Cuarto de Control', 'source': 'EB04' },
        { 'id': 'EB04-ALG', 'nombre': 'Almacén S & I', 'source': 'EB04' },
        { 'id': 'EB04-ADM', 'nombre': 'Of. Admin.', 'source': 'EB04' },
        { 'id': 'EB03-CC', 'nombre': 'Cuarto de Control', 'source': 'EB03' },
        { 'id': 'EB03-ALM', 'nombre': 'Of. Admin.', 'source': 'EB03' },
        { 'id': 'EB02-CC', 'nombre': 'Cuarto de Control', 'source': 'EB02' },
        { 'id': 'EB02-ALM', 'nombre': 'Of. Admin.', 'source': 'EB02' },
        { 'id': 'EB01-CC', 'nombre': 'Cuarto de Control', 'source': 'EB01' },
        { 'id': 'EB01-ALM', 'nombre': 'Of. Admin.', 'source': 'EB01' },
        { 'id': 'EB00-CC', 'nombre': 'Cuarto de Control', 'source': 'EB00' },
        { 'id': 'EB00-ALM', 'nombre': 'Of. Admin.', 'source': 'EB00' },
        { 'id': 'ERM-CC', 'nombre': 'Cuarto de Control', 'source': 'ERM' },
        { 'id': 'ERM-ALM', 'nombre': 'Of. Admin.', 'source': 'ERM' },
        { 'id': 'ERM-ALM', 'nombre': 'Of. Admin.', 'source': 'ERM' },
        { 'id': 'VALV-ALM', 'nombre': 'Gabinete', 'source': 'LPGD' },
      ],
      oficinasSel: []
    }
  },
  watch: {
    itemEdit() {
      this.rellenarForm()
    }
  },
  methods: {
    iniciarComponente() {
      this.isLoading = true
      
      setTimeout(() => {
        this.oficinasSel = this.oficinas.filter( ofi => ofi.source === this.alta.ubicacion )
        this.obtenerTipos()
      }, 1000)

    },

    obtenerOrdenCompra () {
      let year = moment().format('YY')
      let month = moment().format('MM')
      this.ordenCompra = `GIA-${year}${month}-`
    },

    cerrarArticulo () {
      this.limpiarForm()
      this.dataItemEdit = {}
      this.$emit('closeArticulo', false)
      this.$emit('finishEdit', true)
    },

    obtenerTipos () {
      InventarioServices.getCats_Subcats()
        .then(res => {
          console.log(res)
          if (res.length > 0) {
              
            res.forEach(element => {
              let tipoObj = {}
              if (element.subcategoria === '') {
                 tipoObj = {
                  id: element.id,
                  text: `${element.categoria}`,
                  id_cat: element.id, 
                  categoria: `${element.categoria}`,
                  id_sub: element.id_sub,
                  subcategoria: `${element.subcategoria}`
                }
              } else {
                tipoObj = {
                  id: element.id,
                  text: `${element.categoria} - ${element.subcategoria}`,
                  id_cat: element.id, 
                  categoria: `${element.categoria}`,
                  id_sub: element.id_sub,
                  subcategoria: `${element.subcategoria}`
                }
              }
              this.tipos.push(tipoObj)
            });
          }
        })

      setTimeout(() => {
        this.isLoading =false
        this.obtenerOrdenCompra()
      }, 250)

    },

    saveItem () {
      this.isLoading = true
      let idArt = Date.now()
      let idUbi = Date.now()
      InventarioServices.addArticulo(idArt,this.alta.id,this.serie,this.marca,this.modelo,this.observaciones,this.itemSel.id_cat,this.itemSel.categoria,this.itemSel.id_sub,this.itemSel.subcategoria,this.alta.fechaReg,this.alta.ubicacion,this.oficina,this.ordenCompra, this.estado, this.userLogin.id,this.userLogin.nombre,this.userLogin.id,this.userLogin.nombre,idUbi)
        .then(res => {
          console.log(res)
          if (res.success) {
            InventarioServices.addUbicacion(idUbi, idArt, this.alta.fechaReg, this.alta.ubicacion, this.oficina, this.userLogin.id, this.userLogin.nombre, this.userLogin.id, this.userLogin.nombre)
              .then(data => {
                console.log(data)
                if (data.success) {
                  setTimeout(() => {
                    this.isSaved = false
                    this.isEditing = false
                    this.isLoading = false
                    this.limpiarForm()
                    this.$emit('itemSaved', false)
                    this.cerrarArticulo()
                  }, 250)
                } else {
                  this.isLoading = false
                }
              })
          } else {
            this.isLoading = false

          }
        })
    },
    editItem () {
      this.isEditing = true
      this.isSaved = false
    }, 
    updateItem () {
      this.isLoading = true
      InventarioServices.updateItem(this.dataItemEdit.id, this.serie, this.marca, this.modelo, this.observaciones, this.estado, this.itemSel.id_cat,this.itemSel.categoria, this.itemSel.id_sub, this.itemSel.subcategoria, this.oficina, this.ordenCompra)
        .then(res => {
          console.log(res)
          if (res.success) {

            setTimeout(() => {
              this.isSaved = true
              this.isEditing = false
              this.isLoading = false
              this.limpiarForm()
              this.$emit('itemSaved', false)

              this.cerrarArticulo()
            }, 250)

          } else {
            this.isLoading = false

          }
        })
    },
    cancelEditItem () {
      this.isSaved = true
      this.isEditing = false
    },
    limpiarForm () {
      this.serie = ''
      this.marca = ''
      this.modelo = ''
      this.observaciones = ''
      this.estado = ''
      this.dataItemEdit = {}
      this.tipos.length = 0
      this.itemSel = {}
      this.itemData = {}
    },
    estadoInicial () {
      this.isEditing = false
      this.isSaved = false
    },
    rellenarForm () {
      let isNew = Object.keys(this.itemEdit).length === 0
      console.log(isNew)
      if (!isNew) {
        console.log('Es para edicion')
        this.dataItemEdit = this.itemEdit
        this.serie = this.dataItemEdit.serie
        this.marca = this.dataItemEdit.marca
        this.modelo = this.dataItemEdit.modelo
        this.observaciones = this.dataItemEdit.observaciones
        this.estado = this.dataItemEdit.estado
        this.ubicacion = this.dataItemEdit.ubicacion
        this.oficina = this.dataItemEdit.oficina
        this.ordenCompra = this.dataItemEdit.ordenCompra

        let obj = this.tipos.filter( i => i.id_cat === this.dataItemEdit.id_cat && i.id_sub === this.dataItemEdit.id_subcat)
        console.log(obj)
        this.itemData = Object.assign({},this.itemSel, obj[0])

        this.isLoading = false
        this.editItem()
      } else {
        console.log('Es Nuevo')
        this.estadoInicial()
        this.iniciarComponente()
      }
    },
    getTipo: function (id) {
      let result
      let type = this.tipos.filter(tipo => tipo.id === id)
      let tipoEnc = type[0]
      if (tipoEnc.subcategoria === '') {
        result = tipoEnc.categoria
      } else {
        result = `${tipoEnc.categoria} (${tipoEnc.subcategoria})`
      }
      return result
    },
  },
  created () {
    this.iniciarComponente()
  },
  computed: {
    ...mapState(['userLogin'])
  }
}
</script>

<style lang="scss" scoped>
  .section {
    padding-top: 0px;
  }
</style>




// WEBPACK FOOTER //
// src/components/inventario_Componentes/FormArticulo.vue